import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import Floatingcall from "../components/floatingbutton/Floatingcall";
import { Helmet } from "react-helmet";
import LandingPageClient from "../components/ladingpageclient/LandingPageClient";
import {FaUsers} from "react-icons/fa";

function HousekeepingManpower() {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const testimonials = [
    {
      name: "Rahul Sharma",
      role: "Business Owner",
      feedback:
        "The Helper Ji housekeeping staff understood our routine in a few days. We don’t have to keep repeating instructions anymore.",
      image: "https://i.pravatar.cc/150?img=12",
    },
    {
      name: "Neha Verma",
      role: "Working Professional",
      feedback:
        "Work is completed on time, and behavior is respectful. HelperJi's manpower has been reliable so far.",
      image: "https://i.pravatar.cc/150?img=32",
    },
    {
      name: "Amit Singh",
      role: "Corporate Manager",
      feedback:
        "Earlier, helpers used to change frequently. Since Helper Ji provided housekeeping manpower, attendance has been stable.",
      image: "https://i.pravatar.cc/150?img=56",
    },
  ];

    const services = [
        {
          name: "Housekeeping Manpower Services Gurugram",
          link: "/housekeeping-manpower-services-gurugram",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Delhi",
          link: "/housekeeping-manpower-services-delhi",
          icon: <FaUsers />
        },
        {
          name: "Housekeeping Manpower Services Noida",
          link: "/housekeeping-manpower-services-noida",
          icon: <FaUsers />
        }
      ];

  return (
    <Fragment>
      <Helmet>
        >{/* BASIC META */}
        <title>
          Corporate Housekeeping Services in Ghaziabad | Housekeeping Manpower
          Services
        </title>
        <meta
          name="description"
          content="Hire professional corporate housekeeping services in Ghaziabad offering trained housekeeping manpower, staff & housekeeping solutions from a trusted housekeeping company."
        />
        <meta
          name="keywords"
          content="Corporate Housekeeping Services In Ghaziabad, Housekeeping Manpower Services In Ghaziabad, Housekeeping Manpower Agency In Ghaziabad, Housekeeping Company In Ghaziabad, Housekeeping Services For Corporates In Ghaziabad, Professional Housekeeping Manpower"
        />
        {/* ROBOTS */}
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <meta name="revisit-after" content="daily" />
        <meta name="copyright" content="Helper Ji" />
        {/* CANONICAL */}
        <link
          rel="canonical"
          href="https://www.helperji.in/housekeeping-manpower-services-ghaziabad"
        />
        {/* OPEN GRAPH */}
        <meta
          property="og:title"
          content="Corporate Housekeeping Services in Ghaziabad | Housekeeping Manpower Services"
        />
        <meta
          property="og:description"
          content="Hire professional corporate housekeeping services in Ghaziabad offering trained housekeeping manpower, staff & housekeeping solutions from a trusted housekeeping company."
        />
        <meta
          property="og:image"
          content="https://www.helperji.in/assets/img/housekeeping1.png"
        />
        <meta property="og:site_name" content="Helper Ji" />
        <meta
          property="og:url"
          content="https://www.helperji.in/housekeeping-manpower-services-ghaziabad"
        />
        <meta property="og:type" content="website" />
        {/* TWITTER */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@helperji_" />
        <meta name="twitter:creator" content="@helperji_" />
        <meta
          name="twitter:title"
          content="Corporate Housekeeping Services in Ghaziabad | Housekeeping Manpower Services"
        />
        <meta
          name="twitter:description"
          content="Hire professional corporate housekeeping services in Ghaziabad offering trained housekeeping manpower, staff & housekeeping solutions from a trusted housekeeping company."
        />
        <meta
          name="twitter:image"
          content="https://www.helperji.in/assets/img/housekeeping1.png"
        />
        {/* WEBPAGE SCHEMA */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "url": "https://www.helperji.in/housekeeping-manpower-services-ghaziabad",
        "name": "Corporate Housekeeping Services in Ghaziabad | Housekeeping Manpower Services",
        "description": "Hire professional corporate housekeeping services in Ghaziabad offering trained housekeeping manpower, staff & housekeeping solutions from a trusted housekeeping company."
      }
      `}
        </script>
        {/* PRODUCT SCHEMA */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Corporate Housekeeping Services in Ghaziabad",
        "image": "https://www.helperji.in/assets/img/housekeeping1.png",
        "description": "Hire professional corporate housekeeping services in Ghaziabad offering trained housekeeping manpower, staff & housekeeping solutions from a trusted housekeeping company.",
        "brand": {
          "@type": "Brand",
          "name": "Helper Ji"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "ratingCount": "478"
        }
      }
      `}
        </script>
        {/* BREADCRUMB SCHEMA */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.helperji.in"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Housekeeping Manpower Services",
            "item": "https://www.helperji.in/housekeeping-manpower-services"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Housekeeping Manpower Services in Ghaziabad",
            "item": "https://www.helperji.in/housekeeping-manpower-services-ghaziabad"
          }
        ]
      }
      `}
        </script>
        {/* FAQ SCHEMA */}
        <script type="application/ld+json">
          {`
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What corporate housekeeping services do you provide in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "We provide corporate housekeeping services in Ghaziabad, including trained manpower for office cleaning, sanitization, pantry maintenance, and waste management."
            }
          },
          {
            "@type": "Question",
            "name": "Are you a housekeeping company in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji is a professional housekeeping company in Ghaziabad offering reliable manpower services for corporates."
            }
          },
          {
            "@type": "Question",
            "name": "Do you offer a housekeeping manpower agency near me in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, Helper Ji operates as a trusted housekeeping manpower agency in Ghaziabad."
            }
          },
          {
            "@type": "Question",
            "name": "What housekeeping manpower services are available in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our housekeeping manpower services in Ghaziabad include floor cleaning, dusting, sanitizing, restroom cleaning, pantry cleaning, furniture care, and glass cleaning."
            }
          },
          {
            "@type": "Question",
            "name": "Why should I choose Helper Ji in Ghaziabad?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Helper Ji offers trained manpower, cost-effective pricing, and consistent quality in corporate housekeeping services."
            }
          }
        ]
      }
      `}
        </script>
          <script type="text/javascript">
    {`
      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "vuhgim22tp");
    `}
  </script>
      </Helmet>

      <Floatingcall />

      <section id="about" class="about">
        <div class="container" data-aos="fade-up">
          <div class="section-header">
            <h2>Corporate Housekeeping Services in Ghaziabad</h2>
            <p>Reliable Housekeeping Company – Helper Ji</p>
          </div>

          <div class="row gy-4">
            <div class="col-lg-6">
              <img
                src="/assets/img/housekeeping1.png"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>

            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <p className="text-justify">
                  Helper Ji is a dependable housekeeping company in Ghaziabad,
                  providing professional housekeeping manpower services for
                  corporates and commercial establishments. If you are looking
                  for a trusted housekeeping manpower agency near me, we offer
                  trained and supervised staff.
                </p>
                <p className="text-justify">
                  Our housekeeping services for corporates in Ghaziabad focus on
                  maintaining daily cleanliness and hygiene standards.
                </p>
                <h4>Housekeeping Manpower Services in Ghaziabad:</h4>
                <ul>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Floor cleaning and
                    maintenance.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Dusting and
                    sanitising of office areas.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Bathroom and restroom
                    cleaning.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Pantry and kitchen
                    area cleaning.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Garbage management
                    services.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Furniture and
                    upholstery cleaning.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Glass and window
                    cleaning.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Specialised cleaning
                    task.
                  </li>
                </ul>

                <h4 className="pt-3">Why Opt for Helper Ji in Ghaziabad?</h4>
                <ul>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Trusted housekeeping
                    manpower agency.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Skilled and verified
                    manpower.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Cost-effective
                    corporate housekeeping services.
                  </li>
                  <li>
                    <i class="bi bi-check-circle-fill"></i>Fully compliant and
                    reliable.
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="services" class="services sections-bg">
        <div class="container" data-aos="fade-up">
          <div class="row gy-4">
            <div class="col-lg-6">
              <div class="content ps-0 ps-lg-5">
                <h2>
                  Why Choose Helper Ji – Housekeeping Manpower Agency in
                  Ghaziabad?
                </h2>
                <p className="text-justify">
                  Helper Ji is a trusted housekeeping company in Ghaziabad
                  offering reliable corporate housekeeping services with a focus
                  on quality, safety, and consistency.
                </p>
                <ul>
                  <li className="text-justify">
                    <b>Skilled & Verified Manpower:</b> Trained professionals
                    following hygiene and safety protocols.
                  </li>

                  <li className="text-justify">
                    <b>Customised Staffing Solutions:</b> Manpower as per office
                    size and working hours.
                  </li>

                  <li className="text-justify">
                    <b>Cost-effective Services:</b> Affordable housekeeping
                    manpower services without quality compromise.
                  </li>

                  <li className="text-justify">
                    <b>Compliant & Trusted Agency:</b> Adherence to labour laws
                    and industry standards.
                  </li>
                </ul>
                <p className="pt-4">
                  If you are looking for a housekeeping manpower agency near me
                  in Ghaziabad, Helper Ji is the right choice.
                </p>
                <div class="text-center mt-3">
                  <Link
                    to="/contact-us"
                    className="booknow"
                    onClick={scrollToTop}
                  >
                    Book Now
                  </Link>
                </div>
              </div>
            </div>
            <div class="col-lg-6">
              <img
                src="/assets/img/housekeeping4.png"
                class="img-fluid rounded-4 mb-4"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white">
        <div className="container">
          {/* Heading */}
          <div className="text-center mb-5">
            <h2 className="fw-bold">
              What Our <span style={{ color: "#ED1C24" }}>Clients Say</span>{" "}
            </h2>
            <p className="text-muted">
              Trusted by thousands of satisfied customers
            </p>
          </div>

          {/* Testimonials */}
          <div className="row g-4">
            {testimonials.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="card bg-light h-100 shadow-sm border-0 text-center p-4">
                  <img
                    src={item.image}
                    alt={item.name}
                    className="rounded-circle mx-auto mb-3"
                    width="90"
                    height="90"
                  />

                  <p className="text-muted fst-italic">“{item.feedback}”</p>

                  <h5 className="fw-semibold mb-0">{item.name}</h5>
                  <small className="text-danger">{item.role}</small>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="services" class="services sections-bg">
        <div className="container">
          <h3 className="pb-4">
            FAQs – Corporate Housekeeping Services in Ghaziabad
          </h3>
          <div class="accordion accordion-flush" id="accordionFlushExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingOne">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseOne"
                  aria-expanded="false"
                  aria-controls="flush-collapseOne"
                >
                  What corporate housekeeping services do you provide in
                  Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseOne"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  We provide corporate housekeeping services in Ghaziabad,
                  including trained manpower for office cleaning, sanitization,
                  pantry maintenance, and waste management.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseTwo"
                  aria-expanded="false"
                  aria-controls="flush-collapseTwo"
                >
                  Are you a housekeeping company in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingTwo"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, Helper Ji is a professional housekeeping company in
                  Ghaziabad offering reliable manpower services for corporates.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseThree"
                  aria-expanded="false"
                  aria-controls="flush-collapseThree"
                >
                  Do you offer a housekeeping manpower agency near me in
                  Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingThree"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Yes, Helper Ji operates as a trusted housekeeping manpower
                  agency near me in Ghaziabad.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFour"
                  aria-expanded="false"
                  aria-controls="flush-collapseFour"
                >
                  What housekeeping manpower services are available in
                  Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFour"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Our housekeeping manpower services in Ghaziabad include floor
                  cleaning, dusting, sanitizing, restroom cleaning, pantry
                  cleaning, furniture care, and glass cleaning.
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="flush-headingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#flush-collapseFive"
                  aria-expanded="false"
                  aria-controls="flush-collapseFive"
                >
                  Why should I choose Helper Ji in Ghaziabad?
                </button>
              </h2>
              <div
                id="flush-collapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="flush-headingFive"
                data-bs-parent="#accordionFlushExample"
              >
                <div className="accordion-body">
                  Helper Ji offers trained manpower, cost-effective pricing, and
                  consistent quality in corporate housekeeping services.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <LandingPageClient />

       <section className="py-5 sections-bg">
                          <div className="container">
                            <div className="row mb-4">
                              <div className="col text-center">
                                <h2 className="fw-bold">Other Locations</h2>
                                <p className="text-muted">
                                  Explore our other locations of Housekeeping Manpower
                                  Services
                                </p>
                              </div>
                            </div>
                    
                            <div className="row g-4">
                              {services.map((service, index) => (
                                <div className="col-md-4 col-sm-6" key={index}>
                                  <Link
                                    to={service.link}
                                    className="text-decoration-none text-dark"
                                  >
                                    <div className="card h-100 shadow-sm border-0 service-card">
                                      <div className="card-body d-flex align-items-center">
                                        <div className="service-icon me-3">
                                          {service.icon}
                                        </div>
                                        <h6 className="mb-0 fw-semibold">
                                          {service.name}
                                        </h6>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              ))}
                            </div>
                          </div>
                        </section>

    </Fragment>
  );
}

export default HousekeepingManpower;
